import organizationTranslation from "./organizationTranslation";

const opposingLiabilityInsuranceTranslation = {
  ...organizationTranslation,
  legalName: {
    label: "Name Haftpflichtversicherung",
  },
};

export default opposingLiabilityInsuranceTranslation;